 
import { createSlice } from '@reduxjs/toolkit';
import { DICOMViewerState, RunViewerAction } from './DICOMViewer.types';
import { createSliceHook, makeActionCreator } from '../helpers';

const initialState: DICOMViewerState = {
  state: 'idle',
  isViewerDisabled: true,
};

const { act, actEmpty } = makeActionCreator<DICOMViewerState>();

export const DICOMViewerSlice = createSlice({
  name: 'DICOMViewer',
  initialState,
  reducers: {
    downloadDICOMAudit: actEmpty<{
      studies: { studyInstanceUid: string; series: { seriesInstanceUid: string }[] }[];
    }>(),
    fetchNeededData: actEmpty<RunViewerAction['payload']>(),
    fetchNeededDataSuccess: actEmpty(),
    fetchNeededDataFailure: actEmpty<Error>(),
    checkViewer: actEmpty<RunViewerAction['payload']>(),
    runViewer: actEmpty<RunViewerAction['payload']>(),
    loadingViewer: state => {
      state.state = 'loading';
    },
    openViewer: state => {
      state.state = 'opened';
    },
    closeViewer: state => {
      state.state = 'idle';
    },
    setViewerAllowedToLoad: act<boolean>(isViewerDisabled => ({
      isViewerDisabled,
    })),
  },
  selectors: {
    selectDICOMViewerState: (state: DICOMViewerState) => state.state,
  },
});

export const useDICOMViewerSlice = createSliceHook(
  DICOMViewerSlice.name,
  DICOMViewerSlice.actions
);
